export default "__VITE_ASSET__BHNmhdIJ__"